export enum CourseEnrollmentSourceEnum {
  SINGLE_OR_NOT_PROGRAM = '1',
  ALL = '0',
}
